import { StyleSheet } from "react-native";
import { color2, dpToPx } from "../../../../styles";
import { font } from "../../../../styles/themes";
import { CSSProperties } from "react";

export const cssStyles: Record<'extraText', CSSProperties> = {
  extraText: {
    fontFamily: font.family.fromVariable,
    margin: "auto",
    width: "338px",
    display: "block",
    wordBreak: "break-all",
    whiteSpace: 'pre-wrap',
    fontSize: dpToPx(14),
    color: color2.BLUE_DARK,
  },
}

export const styles = StyleSheet.create({
  addressWrapper: {
    paddingVertical: 10,
    paddingHorizontal: 25,
    alignItems: "center",
  },
  star: {
    fontSize: dpToPx(14),
    fontFamily: font.family.fromVariable,
    color: color2.BLUE_DARK,
    letterSpacing: 3,
  },
  address: {
    fontSize: dpToPx(14),
    lineHeight: dpToPx(18),
    fontFamily: font.family.fromVariable,
    color: color2.BLUE_DARK,
    textAlign: "center",
    marginTop: dpToPx(8),
  },
  submitButton: {
    marginTop: dpToPx(15),
    marginBottom: dpToPx(15),
  },
});
